import { Col, Container, Row } from 'react-bootstrap';
import { PageMeta } from '../../components/meta/PageMeta';
import './MediaInquiriesSection.css';

export const MediaInquiriesSection = () => {
  return (
    <div className="mediaInquiries bg-white">
      <PageMeta
        title="Media Inquiries"
        description="Sticky Fingers Cooking has served over 50,000 children since 2011! For media inquiries about our company, please contact ALH Communications at 303-877-0738."
      />
      <Container
        fluid
        className="bg-header d-flex text-white"
      >
        <div className="d-flex justify-content-center align-items-center title-container">
          <h1 className="align-items-center text-center">Media Inquiries</h1>
        </div>
      </Container>

      <Container>
        <div className="column-content media-inquiries-content">
          <div className="content-section">
            <p className="intro-text">
              A home-grown Colorado company, Sticky Fingers Cooking has been{' '}
              <strong>Cultivating 'Cool'inary Curiosity in Kids®</strong> in online classes and at
              hundreds of schools, camps, and special events since 2011.
            </p>

            <p>
              If you're a member of the media and would like to talk about Sticky Fingers Cooking,
              please reach out to Abby Hagstrom at ALH Communications.
            </p>

            <p>
              <strong>Public Relations & Media Inquiries</strong>
              <br />
              Abby Hagstrom, ALH Communications
              <br />
              <a
                href="mailto:abbylhagstrom@gmail.com"
                className="contact-link"
              >
                abbylhagstrom@gmail.com
              </a>
            </p>

            <p>
              If you're a Sticky Fingers Cooking customer and have a question about the site, please
              visit:
              <br />
              <a
                href="/contact"
                className="customer-link"
                onClick={() => (window.location.href = '/contact')}
              >
                stickyfingerscooking.com/contact
              </a>
            </p>
          </div>
        </div>
      </Container>

      <div className="section-media">
        <Container>
          <Row className="media-columns media-row">
            <Col md={4}>
              <div className="div-media">
                <div className="subheader">FOUNDED</div>
                <div className="heading-jumbo">2011</div>
                <div className="colorful-dots"></div>
              </div>
            </Col>
            <Col md={4}>
              <div className="div-media">
                <div className="subheader">EMPLOYEES</div>
                <div className="heading-jumbo">115</div>
                <div className="colorful-dots"></div>
              </div>
            </Col>
            <Col md={4}>
              <div className="div-media">
                <div className="subheader">CHILDREN TAUGHT</div>
                <div className="heading-jumbo">80,000+</div>
                <div className="colorful-dots"></div>
              </div>
            </Col>
          </Row>

          <Row className="media-row">
            <Col md={4}>
              <div className="div-media">
                <div className="subheader">COOKING CLASSES HELD</div>
                <div className="heading-jumbo">45,000+</div>
                <div className="colorful-dots"></div>
              </div>
            </Col>
            <Col md={4}>
              <div className="div-media">
                <div className="subheader">ADDITIONAL LOCATIONS</div>
                <div className="heading-jumbo-small media-location highlight">
                  <a href="/franchise-opportunities-coming-soon">Your hometown!</a>
                </div>
                <div className="heading-jumbo-small media-location">Chicago, IL</div>
                <div className="heading-jumbo-small media-location">Austin, TX</div>
                <div className="heading-jumbo-small media-location">The Milky Way (online)</div>
                <div className="colorful-dots"></div>
              </div>
            </Col>
            <Col md={4}>
              <div className="div-media">
                <div className="subheader">HEADQUARTERS</div>
                <div className="heading-jumbo">Denver, CO</div>
                <div className="colorful-dots"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
